const translations = {
    hello: "bonjour",
    yes: "oui",
    no: "non",
    'Tárgy:': 'Subject:',
    'Beadvány Részletek': 'Submission Details',
    'First Record': 'Premier Enregistrement',
};
export const translateFn_en = (str) => translations[str] || str;
export const translateFn_hu = (str) => str;
